/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('componentEditorDestination', [
  '$compile',

  function ($compile) {
    return {
      controller: 'ComponentEditorDestinationController',

      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./_component-editor-destination.html'),

      replace: true,

      link(scope, element, attrs) {
        element.append($compile(scope.component.editorDirective)(scope));
      },
    };
  },
]);
